import React from 'react';
import { Box, Typography, Paper, alpha } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

const PRIMARY = '#1565C0';

function formatDay(day) {
  if (!day) return '';
  const lower = day.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function SmsConfirmationHours({ hours }) {
  if (!hours || hours.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1.5,
          backgroundColor: alpha(PRIMARY, 0.06),
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <AccessTime sx={{ fontSize: 20, color: PRIMARY }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: PRIMARY }}>
          Hours of Operation
        </Typography>
      </Box>

      <Box sx={{ px: 2, py: 1 }}>
        {hours.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 2,
              py: 1.25,
              borderBottom: index < hours.length - 1 ? '1px solid' : 'none',
              borderColor: alpha('#000', 0.06),
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {formatDay(item.day)}
              </Typography>
              {item.note && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                  {item.note}
                </Typography>
              )}
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: item.status ? 'text.primary' : 'text.secondary',
                whiteSpace: 'nowrap',
                textAlign: 'right',
              }}
            >
              {item.status ? `${item.start} – ${item.end}` : 'Closed'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default SmsConfirmationHours;
